/* ============================================================
   NOVA — Animations v2.0 — Premium Physics Engine
   Scroll Reveal · Marquee · Header · Magnetic · Spotlight ·
   Text Scramble · Counter · Cursor Light · Scroll Progress
============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     UNA SOLA ESECUZIONE PER PAGINA
     ------------------------------------------------------------
     Questo file viene incluso da quasi ogni sezione NOVA con
     {{ 'nova-animations.js' | asset_url | script_tag }}. Il browser
     lo SCARICA una volta sola, ma lo ESEGUE una volta per ogni tag:
     in home ce ne sono quattro (header, quote band, persone, news).
     Risultato: quattro click handler sull'hamburger. Un tocco apriva
     il menu, lo richiudeva, lo riapriva e lo richiudeva — con un
     numero pari di sezioni il drawer non si apriva mai. Da fuori
     sembrava un pulsante morto. Con questa guardia l'init gira una
     volta e i gestori sono uno per elemento.
  ────────────────────────────────────────────────────────── */
  if (window.__novaAnimations) return;
  window.__novaAnimations = true;

  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ──────────────────────────────────────────────────────────
     SCROLL REVEAL — IntersectionObserver, supports blur
  ────────────────────────────────────────────────────────── */
  function initReveal() {
    const els = document.querySelectorAll(
      '.nova-reveal, .nova-reveal-fade, .nova-reveal-left, .nova-reveal-scale'
    );
    if (!els.length) return;

    /* Senza IntersectionObserver niente resta invisibile: il testo
       nasce con opacity 0 e senza JS non tornerebbe mai indietro. */
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      /* Soglia 0.01, non 0.1.
         Con 0.1 l'elemento deve mostrare un decimo di SE STESSO, non
         del riquadro: il corpo di un articolo su telefono e' alto
         cinque schermate, un decimo sono mezza schermata, e finche'
         non si e' scrollato fin li' il testo resta a opacity 0. Da
         fuori: articolo aperto, pagina bianca. Con 0.01 basta che
         affacci. */
      { threshold: 0.01, rootMargin: '0px 0px -48px 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  /* ──────────────────────────────────────────────────────────
     MARQUEE — seamless loop with clone
  ────────────────────────────────────────────────────────── */
  /* Rete di sicurezza: qualunque cosa succeda — un errore altrove,
     un observer che non scatta, un elemento fuori dal flusso — dopo
     tre secondi il testo si vede. Nessuna animazione vale una pagina
     vuota. */
  function revealFallback() {
    setTimeout(function () {
      document.querySelectorAll(
        '.nova-reveal:not(.is-visible), .nova-reveal-fade:not(.is-visible), ' +
        '.nova-reveal-left:not(.is-visible), .nova-reveal-scale:not(.is-visible)'
      ).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) el.classList.add('is-visible');
      });
    }, 3000);
  }

  function initMarquee() {
    document.querySelectorAll('.nova-marquee-track').forEach((track) => {
      const duration  = track.dataset.duration  || '32s';
      const direction = track.dataset.direction === 'right' ? 'reverse' : 'normal';
      track.style.animationDuration  = duration;
      track.style.animationDirection = direction;

      Array.from(track.children).forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     SCROLL PROGRESS BAR — top-of-page thin line
  ────────────────────────────────────────────────────────── */
  function initScrollProgress() {
    if (REDUCED_MOTION) return;

    const bar = document.createElement('div');
    bar.id = 'nova-scroll-progress';
    document.body.appendChild(bar);

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      requestAnimationFrame(() => {
        const scrollTop  = window.scrollY;
        const docHeight  = document.documentElement.scrollHeight - window.innerHeight;
        const progress   = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        bar.style.width  = `${progress}%`;
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  /* ──────────────────────────────────────────────────────────
     HEADER SCROLL — hide/show + scrolled state
  ────────────────────────────────────────────────────────── */
  function initHeader() {
    const header = document.querySelector('.nova-header');
    if (!header) return;

    let lastY   = 0;
    let ticking = false;

    function update() {
      const y = window.scrollY;

      // Solo lo shrink. L'header resta visibile anche scorrendo verso il basso:
      // su una pagina da 8.000px nascondere la navigazione costa più di quanto rende.
      header.classList.toggle('nova-header--scrolled', y > 48);

      lastY   = y;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ──────────────────────────────────────────────────────────
     MEGA MENU — hover with delay + keyboard
  ────────────────────────────────────────────────────────── */
  function initMegaMenu() {
    const header  = document.querySelector('.nova-header');
    const bar     = header && header.querySelector('.nova-header__bar');
    const trigger = document.querySelector('.nova-nav__item--has-dropdown');
    const panel   = document.getElementById('nova-mega');
    const btn     = trigger && trigger.querySelector('.nova-nav__link');
    const scrim   = header && header.querySelector('.nova-mega__scrim');
    if (!header || !bar || !trigger || !panel || !btn) return;

    let openTimer = null;
    let closeTimer = null;
    let hideTimer = null;
    let isOpen = false;

    // Zona viva: tutta la pill (logo, menu, ricerca, carrello) più il pannello.
    // Finché il puntatore è qui dentro il menu resta aperto, comunque si muova.
    // Ragionare per zone invece che per singoli elementi rende la cosa immune
    // a spazi vuoti, sovrapposizioni e riposizionamenti.
    const zones = [bar, panel];
    function inside(node) {
      if (!node || !node.nodeType) return false;
      for (let i = 0; i < zones.length; i++) {
        if (zones[i].contains(node)) return true;
      }
      return false;
    }

    function open() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      clearTimeout(hideTimer);
      if (isOpen) return;
      isOpen = true;
      panel.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!isOpen) return;
          header.classList.add('is-mega-open');
          trigger.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        });
      });
    }

    function close(delay) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (!isOpen) return;
        isOpen = false;
        header.classList.remove('is-mega-open');
        trigger.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        hideTimer = setTimeout(function () { if (!isOpen) panel.hidden = true; }, 560);
      }, delay === undefined ? 240 : delay);
    }

    // Ritardo in apertura: attraversare "Prodotti" per andare altrove
    // non deve far sbattere il pannello in faccia.
    function openSoon() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(open, 90);
    }

    trigger.addEventListener('mouseenter', openSoon);

    // Un solo giudice per la chiusura: dove sta andando il puntatore.
    // mouseout dà relatedTarget, cioè l'elemento in cui sta entrando:
    // se è ancora nella zona viva non succede niente.
    document.addEventListener('mouseover', function (e) {
      if (isOpen && inside(e.target)) clearTimeout(closeTimer);
    });
    document.addEventListener('mouseout', function (e) {
      if (!isOpen) return;
      if (inside(e.relatedTarget)) return;
      close();
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen) { close(0); } else { open(); }
    });
    btn.addEventListener('focus', open);

    // Lo scrim chiude al click, mai al passaggio del mouse.
    if (scrim) scrim.addEventListener('click', function () { close(0); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { close(0); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (isOpen && !inside(e.target)) close(0);
    });
    panel.addEventListener('focusout', function (e) {
      if (!inside(e.relatedTarget)) close(0);
    });
  }

  /* ──────────────────────────────────────────────────────────
     MOBILE DRAWER — full-screen overlay with stagger
  ────────────────────────────────────────────────────────── */
  function initMobileDrawer() {
    const toggle  = document.querySelector('.nova-header__hamburger');
    const drawer  = document.querySelector('.nova-drawer');
    const overlay = document.querySelector('.nova-drawer-overlay');
    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');

      /* Stagger nav items in */
      drawer.querySelectorAll('.nova-drawer__nav > li').forEach((li, i) => {
        li.style.transitionDelay = `${i * 60 + 80}ms`;
        li.classList.add('is-visible');
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');

      drawer.querySelectorAll('.nova-drawer__nav > li').forEach((li) => {
        li.style.transitionDelay = '';
        li.classList.remove('is-visible');
      });
    }

    toggle.addEventListener('click', () => {
      toggle.getAttribute('aria-expanded') === 'true' ? closeDrawer() : openDrawer();
    });
    overlay?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    /* La ✕ del pannello non era collegata a niente: si chiudeva solo
       toccando fuori o con Esc — e su un telefono non c'è Esc.
       Finora non si notava perché il pannello non si apriva mai. */
    drawer.querySelector('.nova-drawer__close')?.addEventListener('click', closeDrawer);

    /* Toccando un link il pannello si chiude subito, senza aspettare
       il caricamento della pagina: altrimenti resta lì aperto mentre
       il sito carica sotto, e sembra che il tocco non sia arrivato. */
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('a[href]')) closeDrawer();
    });

    /* Mobile sub-accordion */
    document.querySelectorAll('.nova-drawer__accordion-trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.nextElementSibling;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     HERO ENTRANCE — blur + stagger + spring
  ────────────────────────────────────────────────────────── */
  function initHeroEntrance() {
    const hero = document.querySelector('.nova-hero');
    if (!hero) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        hero.querySelectorAll('.nova-hero__animate').forEach((el, i) => {
          el.style.transitionDelay = `${i * 110 + 120}ms`;
          el.classList.add('is-visible');
        });
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     HERO PARALLAX — subtle image shift on scroll
     (disabled automatically when packaging animation is active)
  ────────────────────────────────────────────────────────── */
  function initHeroParallax() {
    const visual = document.querySelector('.nova-hero__visual');
    if (!visual || REDUCED_MOTION) return;
    if (document.querySelector('.nova-hero__pkg-open')) return;

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < window.innerHeight * 1.5) {
          visual.style.transform = `translateY(${y * 0.10}px)`;
        }
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  /* ──────────────────────────────────────────────────────────
     PACKAGING SCROLL — crossfade closed→open on hero scroll
  ────────────────────────────────────────────────────────── */
  function initPackagingScroll() {
    if (REDUCED_MOTION) return;

    const hero      = document.querySelector('.nova-hero');
    const pkgClosed = document.querySelector('.nova-hero__pkg-closed');
    const pkgOpen   = document.querySelector('.nova-hero__pkg-open');
    if (!hero || !pkgClosed || !pkgOpen) return;

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    let ticking = false;

    function update() {
      const rect    = hero.getBoundingClientRect();
      const heroH   = hero.offsetHeight;
      const scrolled = Math.max(0, -rect.top);
      const raw     = Math.min(1, scrolled / (heroH * 0.68));
      const p       = easeInOutCubic(raw);

      pkgClosed.style.opacity   = String((1 - p).toFixed(4));
      pkgClosed.style.transform = `scale(${(1 - p * 0.06).toFixed(4)}) translateY(${(-p * 18).toFixed(2)}px)`;

      pkgOpen.style.opacity   = String(p.toFixed(4));
      pkgOpen.style.transform = `scale(${(0.93 + p * 0.07).toFixed(4)}) translateY(${((1 - p) * 22).toFixed(2)}px)`;

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    update();
  }

  /* ──────────────────────────────────────────────────────────
     MAGNETIC BUTTONS — spring physics via CSS custom props
  ────────────────────────────────────────────────────────── */
  function initMagneticButtons() {
    if (REDUCED_MOTION || window.matchMedia('(pointer: coarse)').matches) return;

    document.querySelectorAll('.nova-btn--primary, .nova-btn--sage').forEach((btn) => {
      let animFrame;

      btn.addEventListener('mousemove', (e) => {
        cancelAnimationFrame(animFrame);
        animFrame = requestAnimationFrame(() => {
          const rect = btn.getBoundingClientRect();
          const cx   = rect.left + rect.width  / 2;
          const cy   = rect.top  + rect.height / 2;
          const dx   = (e.clientX - cx) * 0.28;
          const dy   = (e.clientY - cy) * 0.28;
          btn.style.setProperty('--mx', `${dx}px`);
          btn.style.setProperty('--my', `${dy}px`);
        });
      });

      btn.addEventListener('mouseleave', () => {
        cancelAnimationFrame(animFrame);
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     SPOTLIGHT CARDS — cursor-reactive border glow
  ────────────────────────────────────────────────────────── */
  function initSpotlightCards() {
    if (REDUCED_MOTION || window.matchMedia('(pointer: coarse)').matches) return;

    document.querySelectorAll('.nova-card').forEach((card) => {
      let animFrame;

      card.addEventListener('mousemove', (e) => {
        cancelAnimationFrame(animFrame);
        animFrame = requestAnimationFrame(() => {
          const rect = card.getBoundingClientRect();
          const x    = (((e.clientX - rect.left) / rect.width)  * 100).toFixed(2);
          const y    = (((e.clientY - rect.top)  / rect.height) * 100).toFixed(2);
          card.style.setProperty('--spotlight-x', `${x}%`);
          card.style.setProperty('--spotlight-y', `${y}%`);
        });
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     TEXT SCRAMBLE — matrix-style character decode
  ────────────────────────────────────────────────────────── */
  const SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789·—';

  function scrambleText(el, finalText, duration) {
    if (REDUCED_MOTION) { el.textContent = finalText; return; }
    const steps = 14;
    const delay = duration / steps;
    let   step  = 0;

    const interval = setInterval(() => {
      const progress = step / steps;
      el.textContent = Array.from(finalText).map((char, i) => {
        if (char === ' ') return ' ';
        if (i < finalText.length * progress) return char;
        return SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
      }).join('');

      step++;
      if (step > steps) { el.textContent = finalText; clearInterval(interval); }
    }, delay);
  }

  function initTextScramble() {
    const els = document.querySelectorAll('[data-scramble]');
    if (!els.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el      = entry.target;
          const text    = el.dataset.scramble || el.textContent;
          const dur     = parseInt(el.dataset.scrambleDuration) || 700;
          scrambleText(el, text, dur);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    els.forEach((el) => {
      if (!el.dataset.scramble) el.dataset.scramble = el.textContent;
      io.observe(el);
    });
  }

  /* ──────────────────────────────────────────────────────────
     COUNTER ANIMATION — animate numeric values on entry
  ────────────────────────────────────────────────────────── */
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function animateCounter(el) {
    if (REDUCED_MOTION) return;

    const raw    = el.dataset.counter || el.textContent;
    const target = parseFloat(raw.replace(/[^0-9.]/g, ''));
    const prefix = raw.match(/^[^0-9]*/)?.[0]  || '';
    const suffix = raw.match(/[^0-9.]*$/)?.[0]  || '';
    const decimals = (raw.split('.')[1] || '').length;
    const duration = 1400;
    const start    = performance.now();

    function step(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const value    = easeOutQuart(progress) * target;
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    const els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });

    els.forEach((el) => io.observe(el));
  }

  /* ──────────────────────────────────────────────────────────
     IMAGE PARALLAX — subtle depth on scroll for media blocks
  ────────────────────────────────────────────────────────── */
  function initImageParallax() {
    if (REDUCED_MOTION) return;

    const images = document.querySelectorAll('[data-parallax]');
    if (!images.length) return;

    let ticking = false;
    function update() {
      images.forEach((img) => {
        const rect   = img.closest('[data-parallax-wrap]')?.getBoundingClientRect() || img.getBoundingClientRect();
        const cy     = rect.top + rect.height / 2;
        const vy     = window.innerHeight / 2;
        const offset = (cy - vy) * (parseFloat(img.dataset.parallax) || 0.08);
        img.style.transform = `translateY(${offset}px)`;
      });
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ──────────────────────────────────────────────────────────
     INIT — DOM ready + Shopify section reload
  ────────────────────────────────────────────────────────── */
  function init() {
    initReveal();
    revealFallback();
    initMarquee();
    initScrollProgress();
    initHeader();
    initMegaMenu();
    initMobileDrawer();
    initHeroEntrance();
    initHeroParallax();
    initPackagingScroll();
    initMagneticButtons();
    initSpotlightCards();
    initTextScramble();
    initCounters();
    initImageParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    initReveal();
    initMarquee();
    initTextScramble();
    initCounters();
    initMagneticButtons();
    initSpotlightCards();
  });

})();